import {_POST, _GET, _PUT, _GET_BLOB} from "./Api"

export const AppApi = {

    webToken: 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdWQiOiJ3ZWItYXBpIiwidGVuYW50SWQiOiJiNmUxNTk3Zi1jZTYwLTQ0MzItOThhZS02ZTkwMTViN2M5NTgiLCJyb2xlIjoiV0VCIiwiaWF0IjoxNzc4OTY2NDMyfQ.k3tCJz13STPApJq8DZtgomigCxd1lJSroKSaun4cx5p0fk5bONn5XAFO6DMI2nAgCHLF4bb6stX7QageueibkA',

    pub: {

        getAgb: () => _GET("/modules/bildungsurlaub/api/agb", null, AppApi.webToken),
        getImpressum: () => _GET("/modules/bildungsurlaub/api/impressum", null, AppApi.webToken),
        getDatenschutz: () => _GET("/modules/bildungsurlaub/api/datenschutz", null, AppApi.webToken),

        urlTrips: '/modules/bildungsurlaub/api/trips',
        getTrips: (filter) => _GET(AppApi.pub.urlTrips, filter, AppApi.webToken),
        getTrip: (id, filter) => _GET(AppApi.pub.urlTrips+"/" + id, filter, AppApi.webToken),
        putTrip: (body) => _PUT(AppApi.pub.urlTrips, body, AppApi.webToken),

        urlTripImages: '/api/attachments',
        getTripImages: (id) => _GET_BLOB(AppApi.pub.urlTripImages+"/" + id, null, AppApi.webToken),
        urlTripOptionLocations: '/modules/bildungsurlaub/api/trip/option/locations',
        getTripOptionLocations: (filter) => _GET(AppApi.pub.urlTripOptionLocations, filter, AppApi.webToken),
        urlTripOptionLanguages: '/modules/bildungsurlaub/api/trip/option/languages',
        getTripOptionLanguages: (filter) => _GET(AppApi.pub.urlTripOptionLanguages, filter, AppApi.webToken),
        urlTripOptionAppointmentLengths: '/modules/bildungsurlaub/api/trip/option/appointmentLengths',
        getTripOptionAppointmentLengths: (filter) => _GET(AppApi.pub.urlTripOptionAppointmentLengths, filter, AppApi.webToken),
        urlTripOptionStates: '/modules/bildungsurlaub/api/trip/option/states',
        getTripOptionStates: (filter) => _GET(AppApi.pub.urlTripOptionStates, filter, AppApi.webToken),

        urlBookings: '/modules/bildungsurlaub/api/bookings',
        getBookings: (filter) => _GET(AppApi.pub.urlBookings, filter, AppApi.webToken),
        getBooking: (id, filter) => _GET(AppApi.pub.urlBookings+"/" + id, filter, AppApi.webToken),
        postBookingRequest: (body) => _POST(AppApi.pub.urlBookings+':requests', body, AppApi.webToken),
        postBookingConfirm: (body) => _POST(AppApi.pub.urlBookings+':confirm', body, AppApi.webToken),
        urlBookingEvents: '/modules/bildungsurlaub/api/booking/events',
        postBookingEvent: (body) => _POST(AppApi.pub.urlBookingEvents, body, AppApi.webToken),
    },
}